//page-1
export const endpoints = {
  getIndustryList: `IndustryUsecases`,//Changed
  genesysDetails: {
    // syncCustomerRoleToLambdas:"SyncCustomerRoleToLambdas",
    startMigration:"start-task",
    getProcess:"status",
    clientCredentials:"ClientCredentials",
    GenesysConnectConfig:"StoringGenesysConnectConfig",
    migrateUsersRolesQueues: "migratedata",//Changed
    createQueues: "CreatingQueues",//Changed
    createSecurityProfiles: "CreatingSecurityProfiles",//Changed
    createRoutingProfiles:"CreatingRoutingProfiles",//Changed
    createUsers:"CreatingUsers",//Changed
    uploadCustomerProfiles:"UploadingCustomerProfiles",
    createCustomerProfiles:"CreatingCustomerProfiles",//adde
    uploadQueueMetrics:"UploadingQueueMetrics",
    UiQueueMetrics:"QueueMetricsToUI",
    UploadAgentMetrics:"UploadingAgentMetrics",
    UiAgentMetrics:"AgentMetricsToUI",
    UploadSentimentAnalysisMetrics:"UploadingSentimentAnalysisMetrics",
    UiSentimentAnalysisMetrics:"SentimentAnalysisMetricsToUI",
    UploadCallRecordings:"UploadingCallRecordings",
    UiCallRecordingsMetrics:"CallRecordingsMetricsToUI",
  },
  othersDetails: {
    detailsSubmit: "OtherForm",//Changed
  },

  //page-2
  claimPhoneNumber: {
    getCountryList: "CountriesList",//Changed
    claim: "SearchAvailablePhoneNumbers",//Changed
    claimNumber: "ClaimPhoneNumber",//Changed
    bucketCreationSKPIAnalytics:"BucketCreation",//Changed
    instanceStorageConfig:'InstanceStorageConfig'//Updated
  },

  //page-3
  adminDetails: {
    detailsSubmit: "AddAdministrator",//Changed
    allowChatSubmit: "CreateBot",//Changed
    allowChatEmail: "AllowChatbotSes",//Changed
    agentActivity: "AgentActivity",//Changed
    ctr : "CtrSkpi",//Changed
    realTimeMetrics: "RealtimeMetricsSkpi",//Changed
  },

  //page-4
  selectQueues: {
    getCountryTimeZoneList: `TimeZones`,//Changed
    customPromptHandling: "CheckCustomPrompt",//Changed
    createContactFlow: "CreateContactFlow",//needToUpdate
    createHOPQueue: "CreatingHoursOfOperationandQueues",//needToUpdate
    addIntents: "AddIntents",//Changed
    voiceMailHandling: "VoicemailSES",//Changed
    buildBot: "BuildBot",//Changed
    contactFlowLogsSKPI:"FlowLogsTransferSkpi",//Added
    LexlogosSKPI:"LexBotLogsSkpi",//Added
    callRecording:"BucketRetention"//Changed
  },

  //page-5
  agentDetails: {
    detailsSubmit: "AddAgentsManually",//Changed
    csvTemplateDownload : "rapidconnectadduserscsvprod/User_management.csv",//NeedToChangeBucketName
    csvTemplateUpload: "UploadAgentDetailsCSVToS3Buckets",//Changed
    bulkUsersCreation: "TransferingCsv",//Changed
  },

  //page-6
  salesForceDetails: {
    detailsSubmit: "SalesforceIntegration",//Changed
  },
 
  //Last-Page
  successPage: {
    successMail: "SuccessMail",//Changed
    detachPolicy:"STSDetachPolicy"
  },

  //error-logs
  errorLoggers: "ErrorLogs",//Changed

  loginCred:"loginCredentials"
};


